import { formatDuration } from '@lunary/app-core/format-duration'
import { cycleVoiceSpeed, useVoicePlayback, useVoiceToggle } from './voice-playback'
import { VoiceWave } from './voice-wave'
import styles from './voice.module.css'

export type VoiceMessageProps = {
  id: string
  src: string | null
  durationMs: number
  peaks: readonly number[] | null
  unheard?: boolean
  size?: 'bubble' | 'hero' | 'compact'
  mine?: boolean
}

const PLAY = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M8 5.5v13l11-6.5z" />
  </svg>
)
const PAUSE = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" />
  </svg>
)

export function VoiceMessage({ id, src, durationMs, peaks, unheard = false, size = 'bubble', mine = false }: VoiceMessageProps) {
  const playback = useVoicePlayback(id)
  const toggle = useVoiceToggle(id, src)
  const playing = playback.active && playback.playing
  const position = playback.active ? playback.positionMs : 0
  const progress = durationMs > 0 ? Math.min(1, position / durationMs) : 0
  const bars = size === 'hero' ? 64 : size === 'compact' ? 32 : 40
  return (
    <div className={`${styles.voice} ${styles[size]} ${mine ? styles.mine : ''}`}>
      <button
        type="button"
        className={styles.play}
        onClick={() => toggle()}
        disabled={!src}
        aria-label={playing ? 'Пауза' : 'Слушать'}
      >
        {playing ? PAUSE : PLAY}
      </button>
      <div className={styles.body}>
        <VoiceWave peaks={peaks ?? []} progress={progress} bars={bars} onSeek={src ? (f) => toggle(f) : undefined} />
        <div className={styles.info}>
          <span>{formatDuration(playback.active && position > 0 ? position : durationMs)}</span>
          {unheard && !playback.active && <span className={styles.unheard} title="Не прослушано" />}
          <span className={styles.grow} />
          {playback.active && (
            <button type="button" className={styles.speed} onClick={cycleVoiceSpeed} aria-label="Скорость">
              {String(playback.speed).replace('.', ',')}×
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
